import { CSSProperties } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import qrCodePlaceholder from '@/assets/images/qrCodePlaceholder.png'

interface TableCardQrCodeProps {
  /**
   * The URL the QR encodes. When omitted (e.g. a template preview not tied to a
   * specific table) the placeholder image is shown instead.
   */
  value?: string
  className?: string
  style?: CSSProperties
}

/**
 * Renders a table card's QR code on the frontend (qrcode.react) instead of
 * loading a backend-generated image. Black on white for reliable scanning;
 * sizing/positioning comes from the template's `qrCodeImage` class.
 */
function TableCardQrCode({ value, className, style }: TableCardQrCodeProps) {
  if (!value) {
    return (
      <img
        className={className}
        style={style}
        src={qrCodePlaceholder}
        alt="QR Code"
      />
    )
  }

  return (
    <QRCodeSVG
      className={className}
      style={style}
      value={value}
      level="H"
      width="100%"
      height="100%"
    />
  )
}

export default TableCardQrCode
